// Passenger types
export const PASSENGER_TYPES = {
  ADULT: "adult", // Yetişkin (18+)
  STUDENT: "student", // Öğrenci (12-24 yaş)
  CHILD: "child", // Çocuk (2-11 yaş)
  INFANT: "infant", // Bebek (2 yaş altı)
  // ELDERLY: "elderly", // Yaşlı (65 ve üstü)
};

// Cabin classes
export const CABIN_CLASSES = {
  ECONOMY: "economy",
  BUSINESS: "business",
};

// Default values
export const defaultPassengerCounts = {
  [PASSENGER_TYPES.ADULT]: 1,
  [PASSENGER_TYPES.STUDENT]: 0,
  [PASSENGER_TYPES.CHILD]: 0,
  [PASSENGER_TYPES.INFANT]: 0,
  // [PASSENGER_TYPES.ELDERLY]: 0,
};

export const defaultCabinClass = CABIN_CLASSES.ECONOMY;
